import { render, staticRenderFns } from "./loginTwo.vue?vue&type=template&id=69cf71b4&scoped=true&"
import script from "./loginTwo.vue?vue&type=script&lang=js&"
export * from "./loginTwo.vue?vue&type=script&lang=js&"
import style0 from "./loginTwo.vue?vue&type=style&index=0&id=69cf71b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cf71b4",
  null
  
)

export default component.exports